<template>
    <div class="search_input_box">
        <div class="select_input" :class="isactive?'input_one_active':''">
            <span class="label_name" :class="isMust?'isMust':''">{{name}}</span>
            <el-input v-model="backVal.FullName"  size="mini" :clearable='true' class="input_sty" @focus="doFocus" @blur="doBlur" :disabled="isdisable"  @dblclick.native="searchClick" @clear="clearData" @input="regrexp"></el-input>
            <i class="el-icon-search icon_sty" v-if="permissions" @click="searchClick"></i>
        </div>
        <!-- 收索弹出框 -->
        <ClassificationDialog :show.sync="searchShow" fieldData="backVal" :searchData="searchData" @dateChange="dateChange"  v-bind="$attrs"/>
        <regions v-if="popType == 3" :show.sync="searchShow" @dataname="dateChange" />
        <department v-if="popType == 4" :show.sync="searchShow" @dataname="dateChange" />
    </div>
</template>

<script>
  export default {
    name:"InputSearch",
    data(){
        return{
            isactive:false,//是否聚焦状态
            searchShow:false,//收索弹出框是否显示
            backVal:this.value,//数据
            searchData:{title:'',url:''},//传递给searchClerkDialog的参数
        }
    },
    methods:{
        dataregion(data){
        },
        // 聚焦事件
        doFocus(){
            this.$emit('clickFocus');
            this.isactive = true;
        },
        // 失焦事件
        doBlur(){
            this.$emit('Blur');
            this.isactive = false;
        },
        // 点击input收索icon
        searchClick(){
            this.searchShow = true;
            // this.$emit('clickSearch');
        },
        //回填数据
        dateChange(data){
            // console.log('-------',data);
            let typeId = data.DeptId||data.AreaId||data.KtypeId;
            this.backVal.FullName = data.FullName;
            this.backVal.KtypeId = typeId;
            // this[fieidName].FullName = data.FullName;
            // this[fieidName].KtypeId = data.KtypeId;
            // this.$emit("clickSearch", this.fieldData);
        },
        // 点击input清除数数符号
        clearData() {
            this.backVal.FullName = "";
            this.backVal.KtypeId = Number("");
        },
        // 正则验证input
        regrexp(val) {
            this.backVal.FullName = "";
            this.backVal.KtypeId = Number("");
        },
    },
    props:{
        // 是否显示新增和收索
        permissions: {
            type: Boolean,
            default: true
        },
        placeholder:String,
        // 默认数据值
        value:[Object],
        // lable名称
        name: {
            type: String,
            default: "客户"
        },
        // 是否必填
        isMust:{
            type: Boolean,
            default: true
        },
        isdisable:{
            type: Boolean,
            default: false
        },
        // // 渲染的新增弹出框类型(1为客户、2为仓库、3为经手人)
        // typeDialog:{
        //     type: Number,
        //     default: 1
        // },
        // 分类用的类型（0：客户类（单位）、1：仓库类、2：经手人类（职员）、3：地区、4：部门类、5：商品类、6：银行类）
        popType:{
            type:Number,
        }
    },
    watch:{
        value:{
            handler(newValue, oldValue) {
                this.backVal = newValue;
            },
            deep: true,
            immediate:true
        }
    },
    created(){
        switch (this.popType) {
            case 0:
                this.searchData = {title:'客户目录',url:'/index/Client/getlist'};
                break;
            case 1:
                this.searchData = {title:'仓库目录',url:'/index/Stock/getlist'};
                break;
            case 2:
                this.searchData = {title:'经手人目录',url:'/index/Person/getlist'};
                break;
            case 3:
                this.searchData = {title:'地区目录',url:'/index/Area/getlist'};
                break;
            case 4:
                this.searchData = {title:'部门目录',url:'/index/Department/getlist'};
                break;
            case 5:
                this.searchData = {title:'商品目录',url:'/index/Goods/getlist'};
                break;
            default:
                break;
        }
    },
  }
</script>

<style lang="less">
.search_input_box{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    .select_input{
        width: 100%;
        height: 30px;
        display: -webkit-box !important;
        display: box !important;
        position:relative;
        -webkit-box-align:center;
        box-align:center;
        color: #000;
        border: 1px solid #d6e2ed;
        border-radius: 5px;
        padding: 0 5px;
        box-sizing: border-box;
        .label_name{
            height: 100%;
            line-height: 30px;
            font-size: 12px;
            color: inherit;
            font-weight: bold;
        }
        .isMust::after{
            content: '*';
            color: red;
        }
        .input_sty{
            position:relative;
            -webkit-box-flex: 1; 
            box-flex: 1;
            display: block;
            height: 100%;
        }
        .el-input__inner{
            padding: 0;
            padding-left: 6px;
            height: 27px;
        }
        .el-input__inner,.el-input__inner:hover {
            border-color: #fff;
        }
        .icon_sty{
            margin:0 3px;
            cursor: pointer;
        }
    }
    .el-input.is-disabled .el-input__inner{
        background-color: #fff;
        border-color: #fff;
        color: #333;
    }
    .input_one:hover{
        border-color: #2594ff;
        color: #2594ff;
    }
    .input_one_active{
        border-color: #2594ff!important;
        color: #2594ff!important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/InputSearch/InputSearch.vue